/** This identity is local demonstration data, never a JWT or backend principal. */
export const EXPERIENCE_KID_ID = 'study-experience-learner';
export const STUDY_EXPERIENCE_PATH = '/try/study/student';
export function isStudyStudentExperience(
  pathname = typeof window === 'undefined' ? '' : window.location.pathname,
) {
  return pathname === STUDY_EXPERIENCE_PATH || pathname === `${STUDY_EXPERIENCE_PATH}/`;
}

export interface LiveStudyExperience {
  expires_in: number;
  payer: { name: string; stars_balance: number };
  learner: { sub: string; [key: string]: unknown };
}
let liveSession: LiveStudyExperience | null = null;
export function setLiveStudyExperience(value: LiveStudyExperience | null) {
  liveSession = value;
}
export function getLiveStudyExperience() {
  return liveSession;
}
export function isLiveStudyExperienceRequested() {
  return (
    isStudyStudentExperience() &&
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('experience') === 'live'
  );
}
export function isLocalStudyExperience() {
  return isStudyStudentExperience() && !isLiveStudyExperienceRequested() && !liveSession;
}
